import { makeStyles, Theme } from "@material-ui/core/styles";

const styles = makeStyles((theme: Theme) => ({
  tableFlex: {
    display: 'flex',
    flexDirection: 'column'
  },
  cells: {
    display: 'flex',
    alignItems: 'center',
  },
  noResults: {
    justifyContent: 'center',
  },
  icons: {
    position: 'relative',
    marginRight: 4,
  },
  columnWidthCheckboxes: {
    width: theme.spacing(10),
  },
  borderBottom: {
    borderBottom: 'none',
  },
  availabilityFilterLabel: {
    textTransform: 'none',
  },
  availabilityButton: {
    cursor: 'text',
    fontSize: theme.spacing(2),
    color: theme.palette.constrastGreyDark.main,
    height: theme.spacing(2),
    float: 'left',
    marginTop: theme.spacing(1.25),
    marginBottom: theme.spacing(1.25),
  },
  addNewDarkButton: {
    fontWeight: "bold",
    fontSize: theme.spacing(2),
    lineHeight: "13px",
    padding:theme.spacing(1.5),
    color:"white",
    backgroundColor:"black",
    marginTop: theme.spacing(2),
  },
  divFilters: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& > button': {
      marginRight: theme.spacing(6.25),
    },
    '& > div': {
      marginRight: theme.spacing(6.25),
    },
  },
  divGroups: {
    marginLeft: theme.spacing(3.25),
  },
  divItems: {
    marginLeft: theme.spacing(10),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  divItemsSmallScreen: {
    marginLeft: theme.spacing(6,25),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width:theme.spacing(75),
  },
  divCellText:{
    width:theme.spacing(112.5),
  },
  divCellIconDetails:{
    width:theme.spacing(5),
    marginLeft: theme.spacing(5),
  },
  divCellTextSmallScreen:{
    width:theme.spacing(75),
  },
  divCellIconDetailsSmallScreen:{
    width:theme.spacing(5),
    marginLeft: theme.spacing(1.25),
  },
  root: {
    width: '100%',
  },
  noAttributesTitle:{
    fontWeight: "bold",
    fontSize: theme.spacing(3),
    lineHeight: "28.13px"
  },
  noAttributesSubTitle:{
    fontSize: theme.spacing(2.25),
    lineHeight: "41px"
  },
  infoIcon:{
      width:theme.spacing(8.5),
      height:theme.spacing(8.5)
  },
  container: {
    maxHeight: '60vh',
    minHeight: '60vh',
  },
  tableCell: {
    paddingTop: 16,
    paddingBottom: 16,
    paddingLeft: 8
  },
  link: {
    cursor: 'pointer',
  },
  tableHeaderCell: {
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 8
  }
}));

export default styles;